<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 0;">
      <!-- 搜索表单 -->
      <el-form :model="where" class="ele-form-search ele-table-tool-default" @keyup.enter.native="searchData()" @submit.native.prevent>
        <el-row :gutter="10" style="margin-top: 8px">
          <el-col :lg="7" :md="16" :sm="16" :xs="12">
            <el-form-item label="日期选择:">
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd"
                :unlink-panels="true"
            /></el-form-item>
          </el-col>
          <el-col :lg="16" :md="8" :sm="8" :xs="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="searchData" size="small" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            </div>
          </el-col>
          <el-col :md="24" :sm="24" :xs="24">
            <div class="ele-form-actions">
              <el-button type="primary" @click="exportDataByClass" size="small" icon="el-icon-download" class="ele-btn-icon">按班级导出</el-button>
              <el-button type="primary" @click="exportDataByStudent" size="small" icon="el-icon-download" class="ele-btn-icon">按学生导出</el-button>
              <el-button type="primary" @click="exportDataByDor" size="small" icon="el-icon-download" class="ele-btn-icon">按宿舍导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :data="dorData" highlight-current-row style="padding-bottom: 10px;">
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="branchName" label="部系" show-overflow-tooltip />
          <el-table-column prop="gradeName" label="年级" show-overflow-tooltip />
          <el-table-column prop="className" label="班级" show-overflow-tooltip />
          <el-table-column prop="studentNum" label="学生数量" show-overflow-tooltip />
          <el-table-column prop="ptotal" label="学生行为评价总分" show-overflow-tooltip />
          <el-table-column prop="dtotal" label="宿舍量化总分" show-overflow-tooltip />
          <el-table-column prop="ctotal" label="班级量化总分" show-overflow-tooltip />
          <el-table-column label="操作" align="center">
            <template #default="{ row }">
              <el-link @click="getDetail(row)" icon="el-icon-view" type="primary" :underline="false">明细</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <el-dialog title="查看明细" :visible.sync="showDetail" width="50%">
      <div class="ele-table-tool ele-table-tool-default scope-tool">
        <el-button type="primary" icon="el-icon-download" @click="exportClassData" class="ele-btn-icon" size="small">导出</el-button>
      </div>
      <ele-data-table ref="detailTable" :config="detailTable" height="calc(90vh - 300px)" highlight-current-row>
        <template #default="{ index }">
          <!--          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />-->
          <el-table-column prop="gradeName" label="年级" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="className" label="班级" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="studentName" label="学生姓名" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="score" label="得分" sortable="custom" show-overflow-tooltip />
        </template>
      </ele-data-table>
    </el-dialog>
  </div>
</template>

<script>
  import {
    classCompositeAllExport,
    classCompositeExport,
    compositeExport,
    compositeList,
    dormitoryTotalScoreExport,
    getDormitoryScoreList,
  } from '@/config/api';

  export default {
    name: 'Index',
    data() {
      return {
        date: null,
        aa: null,
        dorData: [],
        where: {
          startTime: null,
          endTime: null,
        },
        detailTable: {
          // 表格配置
          url: '/school/behavior/classCompositeList',
          where: { classId: '', startTime: null, endTime: null },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        showDetail: false,
      };
    },
    created() {
      this.setSelectTime();
      this.searchData();
    },
    methods: {
      // 查询
      searchData() {
        this.where = {
          startTime: this.date[0],
          endTime: this.date[1],
        };
        compositeList(this.where).then((res) => {
          if (res.data.resCode == 200) {
            this.dorData = res.data.data;
          }
        });
      },
      // 默认本月日期
      setSelectTime() {
        var _this = this;
        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

        var start_month = y + '-' + '01'; //开始月份：本年第一月份
        var end_month = `${y}-${m}`; //结束月份： 本年当前月份

        var start_day = y + '-' + m + '-' + '01'; //开始日期： 本月第一天
        var end_day = `${y}-${m}-${d}`; //结束日期： 本月今天

        _this.aa = [start_month, end_month]; //默认月份区间
        _this.date = [start_day, end_day]; //默认日期区间  页面显示的
        this.where.startTime = start_day; // 传入后台的 开始时间
        this.where.endTime = end_day; // 传入后台的 结束时间
      },
      // 导出
      exportDataByClass() {
        let data = {
          startTime: this.date[0],
          endTime: this.date[1],
        };
        compositeExport(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      // 获取明细列表
      getDetail(row) {
        this.showDetail = true;
        this.detailTable.where = {
          classId: row.classId,
          startTime: this.date[0],
          endTime: this.date[1],
        };
        this.$refs.detailTable.doLayout();
        this.$refs.detailTable.reload();
      },
      // 按班级导出
      exportClassData() {
        let data = {
          classId: this.detailTable.where.classId,
          startTime: this.date[0],
          endTime: this.date[1],
        };
        classCompositeExport(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      // 按学生导出
      exportDataByStudent() {
        let data = {
          startTime: this.date[0],
          endTime: this.date[1],
        };
        classCompositeAllExport(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      // 按宿舍导出
      exportDataByDor() {
        let data = {
          startTime: this.date[0],
          endTime: this.date[1],
        };
        dormitoryTotalScoreExport(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          // console.log(objectUrl)
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          // console.log(res.headers)
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          // console.log(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
